import apiClient from './api';

export interface Category {
  id?: number;
  code: string;
  name: string;
  slug?: string;
  image?: string | File;
  description?: string;
  status?: number;
}

const categoryService = {
  async getCategories(): Promise<Category[]> {
    try {
      const response = await apiClient.get('/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  async getCategory(id: number): Promise<Category> {
    try {
      const response = await apiClient.get(`/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching category ${id}:`, error);
      throw error;
    }
  },

  async createCategory(data: FormData): Promise<Category> {
    try {
      const response = await apiClient.post('/categories', data);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  async updateCategory(id: number, data: FormData): Promise<Category> {
    try {
      if (!data.has('_method')) {
        data.append('_method', 'PUT');
      }
      const response = await apiClient.post(`/categories/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${id}:`, error);
      throw error;
    }
  },

  async deleteCategory(id: number): Promise<void> {
    try {
      await apiClient.delete(`/categories/${id}`);
    } catch (error) {
      console.error(`Error deleting category ${id}:`, error);
      throw error;
    }
  },
};

export default categoryService;
